import { KnmHistoryOperationsEnum } from 'APIPackage/KnmModule/enums/KnmHistoryOperationsEnum';

export const knmHistoryFieldOperationsMap = {
  [KnmHistoryOperationsEnum.INSERT]: 'добавлено',
  [KnmHistoryOperationsEnum.UPDATE]: 'изменено',
  [KnmHistoryOperationsEnum.DELETE]: 'удалено',
};
